export default __webpack_public_path__ + "static/media/twitter.d09b078c.svg";